// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_XT5","cls2":"HeroWorkCardHeader-cls2_r5m HeroWorkCardHeader-cls1_XT5"};